import { render, staticRenderFns } from "./AlternativeArticle.vue?vue&type=template&id=fb5c6324&scoped=true"
import script from "./AlternativeArticle.vue?vue&type=script&lang=js"
export * from "./AlternativeArticle.vue?vue&type=script&lang=js"
import style0 from "./AlternativeArticle.vue?vue&type=style&index=0&id=fb5c6324&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fb5c6324",
  null
  
)

export default component.exports